import { render, staticRenderFns } from "./BatchReadings.vue?vue&type=template&id=cb45b6f2&scoped=true"
import script from "./BatchReadings.vue?vue&type=script&lang=js"
export * from "./BatchReadings.vue?vue&type=script&lang=js"
import style0 from "./BatchReadings.vue?vue&type=style&index=0&id=cb45b6f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb45b6f2",
  null
  
)

export default component.exports